import { render, staticRenderFns } from "./SortModal.vue?vue&type=template&id=f70504a0&scoped=true&"
import script from "./SortModal.vue?vue&type=script&lang=js&"
export * from "./SortModal.vue?vue&type=script&lang=js&"
import style0 from "./SortModal.vue?vue&type=style&index=0&id=f70504a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70504a0",
  null
  
)

export default component.exports